interface ErrorNotificationsProps {
    errorMessage: string | null;
}

const ErrorNotification = ({ errorMessage }: ErrorNotificationsProps) => {
    return <>{errorMessage ? <div className="error-notification">{errorMessage}</div> : null}</>;
};

export default ErrorNotification;
